import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Input } from '@/components/ui/input'
import { usePersistentState } from '@/hooks/usePersistentState'

export default function Error() {
  const [filters, setFilter, clearFilters] = usePersistentState<Record<string, any>>(
    'admin:error:filters',
    {},
  )

  const handleResetFilters = () => {
    clearFilters()
  }

  const fields: ManageField[] = [
    {
      desc: '平台',
      field: 'plat',
    },
    {
      desc: '备注名',
      field: 'name',
    },
    {
      desc: '错误码',
      field: 'error_code',
    },
    {
      desc: 'url',
      field: 'path',
    },
    {
      desc: 'msg',
      field: 'msg',
    },
    {
      desc: '更新日期',
      field: 'update_time',
    },
  ]

  const filterUI = (
    <Input
      placeholder="输入备注名"
      className="w-[200px]"
      value={filters.name || ''}
      onChange={(e) => {
        if (e.target.value) {
          setFilter({ name: e.target.value })
        } else {
          setFilter({})
        }
      }}
    />
  )

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">错误管理</h1>
      <ManageTable fields={fields} collect="error" filters={filters} filter={filterUI} onResetFilters={handleResetFilters} />
    </div>
  )
}
